export enum ReferralServiceTypes {
  Broker = 1,
  Agent = 2,
  Client = 3,
}
